import { Card, CardHeader, Text, makeStyles, shorthands, tokens, Caption1, CardFooter, Button } from "@fluentui/react-components";
import { InfoRegular, ErrorCircleRegular, LinkRegular, DocumentRegular, FolderRegular, DocumentMultipleRegular } from "@fluentui/react-icons";
import { ISpecificLinkResultCardProps } from "./specific-link-result-card.props";
import { ILocaleStrings } from "loc/locale.interfaces";
import { useL10n } from "context/l10n-context";
import { getSharingLinkPermissionDisplayText } from "lib/sharing-link-permissions";

const layoutStyles = makeStyles({
    divider: {
        ...shorthands.borderBottom('1px', 'solid', tokens.colorNeutralStrokeSubtle),
        ...shorthands.margin(0, 0, '1em', 0)
    },
    itemWrapper: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        ...shorthands.margin('1em', 0, 0, 0)
    },
    itemImageWrapper: {
        marginRight: tokens.spacingHorizontalM
    },
    textWrapper: {
        ...shorthands.overflow('hidden'),
        '> span': {
            display: 'block',
            ...shorthands.overflow('hidden'),
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap'
        }
    }
});

export default function SpecificLinkResultCard(props: ISpecificLinkResultCardProps) {
    const styles = layoutStyles();
    const { t } = useL10n<ILocaleStrings>();
    
    const { removedLink } = props;

    // Header: "Can edit - 12345-67890-09876-54321"
    const headerTitle = `${getSharingLinkPermissionDisplayText(removedLink.permissionType, t)} - ${removedLink.shareId}`;
    
    // Description: "Project Mayflour document.docx"
    const headerDescription = removedLink.itemName;

    // Get item type icon
    const getItemIcon = (itemType: number): JSX.Element => {
        switch (itemType) {
            case 1: // File
                return <DocumentRegular fontSize={28} />;
            case 2: // Folder
                return <FolderRegular fontSize={28} />;
            default:
                return <DocumentMultipleRegular fontSize={28} />;
        }
    };

    return (
        <Card>
            <CardHeader
                image={<LinkRegular fontSize={28} />}
                header={<div className={styles.textWrapper}><Text as="span">{headerTitle}</Text></div>}
                description={<div className={styles.textWrapper}><Caption1 as="span">{headerDescription}</Caption1></div>}
            />
            <div>
                <div className={styles.divider}></div>
                <Caption1 as="span">{t('ppaRemoveSharingLinksActionRemovedFromItem')}</Caption1>
                <div className={styles.itemWrapper}>
                    <div className={styles.itemImageWrapper}>
                        {getItemIcon(removedLink.itemType)}
                    </div>
                    <div>
                        <div className={styles.textWrapper}><Text as="span">{removedLink.itemName}</Text></div>
                        <div className={styles.textWrapper}><Caption1 as="span">{removedLink.itemUrl}</Caption1></div>
                    </div>
                </div>
            </div>
            <CardFooter>
                {props.messages.length > 0 &&
                    <Button onClick={props.onMessagesClick} icon={<InfoRegular fontSize={16} />}></Button>}
                {props.errorCount > 0 &&
                    <Button onClick={props.onErrorsClick} icon={<ErrorCircleRegular fontSize={16} />}>{props.errorCount} Errors</Button>}
            </CardFooter>
        </Card>
    );
}